/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PccPicklistOption } from './PccPicklistOption';
import {
    PccPicklistOptionFromJSON,
    PccPicklistOptionFromJSONTyped,
    PccPicklistOptionToJSON,
    PccPicklistOptionToJSONTyped,
} from './PccPicklistOption';

/**
 * 
 * @export
 * @interface PccPicklistResponse
 */
export interface PccPicklistResponse {
    /**
     * 
     */
    languages?: Array<PccPicklistOption>;
    /**
     * 
     */
    marital_statuses?: Array<PccPicklistOption>;
    /**
     * 
     */
    prefixes?: Array<PccPicklistOption>;
    /**
     * 
     */
    races?: Array<PccPicklistOption>;
    /**
     * 
     */
    suffixes?: Array<PccPicklistOption>;
}

/**
 * Check if a given object implements the PccPicklistResponse interface.
 */
export function instanceOfPccPicklistResponse(value: object): value is PccPicklistResponse {
    return true;
}

export function PccPicklistResponseFromJSON(json: any): PccPicklistResponse {
    return PccPicklistResponseFromJSONTyped(json, false);
}

export function PccPicklistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPicklistResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'languages': json['languages'] == null ? undefined : ((json['languages'] as Array<any>).map(PccPicklistOptionFromJSON)),
        'marital_statuses': json['marital_statuses'] == null ? undefined : ((json['marital_statuses'] as Array<any>).map(PccPicklistOptionFromJSON)),
        'prefixes': json['prefixes'] == null ? undefined : ((json['prefixes'] as Array<any>).map(PccPicklistOptionFromJSON)),
        'races': json['races'] == null ? undefined : ((json['races'] as Array<any>).map(PccPicklistOptionFromJSON)),
        'suffixes': json['suffixes'] == null ? undefined : ((json['suffixes'] as Array<any>).map(PccPicklistOptionFromJSON)),
    };
}

export function PccPicklistResponseToJSON(json: any): PccPicklistResponse {
    return PccPicklistResponseToJSONTyped(json, false);
}

export function PccPicklistResponseToJSONTyped(value?: PccPicklistResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'languages': value['languages'] == null ? undefined : ((value['languages'] as Array<any>).map(PccPicklistOptionToJSON)),
        'marital_statuses': value['marital_statuses'] == null ? undefined : ((value['marital_statuses'] as Array<any>).map(PccPicklistOptionToJSON)),
        'prefixes': value['prefixes'] == null ? undefined : ((value['prefixes'] as Array<any>).map(PccPicklistOptionToJSON)),
        'races': value['races'] == null ? undefined : ((value['races'] as Array<any>).map(PccPicklistOptionToJSON)),
        'suffixes': value['suffixes'] == null ? undefined : ((value['suffixes'] as Array<any>).map(PccPicklistOptionToJSON)),
    };
}

